<div *ngIf="isLoading" class="loaderdata">
  <div class="spinner-border" role="status">
    <span class="sr-only">{{ "Form.Loading" | translate }}</span>
  </div>
</div>
<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/page/dashboard"
        ><i class="icon text-info fa fa-home"></i
      ></a>
    </li>

    <li class="breadcrumb-item active" aria-current="page">
      {{ currentProject.name }}
    </li>
  </ol>
</nav>
<div class="row">
  <div class="col-md-12">
    <div class="card main-card mb-3">
      <div class="card-body">
        <div class="row mb-3">
          <div
            class="col-md-12 col-xl-12 d-flex text-left"
            style="margin: 0px 10px; padding: 8px"
          >
            <select
              [(ngModel)]="selectedVersion"
              style="height: 35px !important"
              (change)="onFilterChange()"
              class="card px-3 py-2 m-2"
            >
              <option
                style="color: #3f6ad8"
                *ngFor="let item of versionList"
                [value]="item.id"
              >
                {{ item.version }} ({{
                  item.releaseDate | date : "dd MMM yyyy"
                }})
              </option>
            </select>
            <select
              [(ngModel)]="selectedLanguage"
              style="height: 35px !important"
              (change)="onFilterChange()"
              class="card px-3 py-2 m-2"
            >
              <option
                style="color: #3f6ad8"
                *ngFor="let item of filteredLanguages"
                [value]="item.id"
              >
                {{ item.name }}
              </option>
            </select>
            <select
              (change)="onEnviornmentChange($event.target.value)"
              class="card col-1 px-3 py-2 m-2"
              style="height: 35px !important"
            >
              <option
                style="color: #3f6ad8"
                *ngFor="let item of enviornment"
                [value]="item.value"
              >
                {{ item.label }}
              </option>
            </select>
            <div class="card px-3 m-2" style="height: 35px !important">
              <div style="padding-top: 5px">
                <input
                  type="radio"
                  [(ngModel)]="selectedTransitOption"
                  (change)="onFilterChange()"
                  value="lastTransit"
                  name="lastTransit"
                />
                <label
                  style="
                    position: relative;
                    bottom: 7px;
                    padding-left: 8px;
                    padding-right: 10px;
                  "
                  >{{ "Form.LastTransit" | translate }}</label
                >
                <input
                  type="radio"
                  [(ngModel)]="selectedTransitOption"
                  (change)="onFilterChange()"
                  value="date"
                  name="lastTransit"
                />
                <label
                  style="
                    position: relative;
                    bottom: 7px;
                    padding-left: 8px;
                    padding-right: 10px;
                  "
                  >{{ "Form.Date" | translate }}</label
                >
              </div>
            </div>
            <div
              class="filter"
              style="height: 35px !important; margin: 15px"
              *ngIf="selectedTransitOption === 'date'"
            >
              <label for="date">{{ "Form.SelectDate" | translate }}:</label>
            </div>
            <mat-form-field
              appearance="fill"
              *ngIf="selectedTransitOption === 'date'"
            >
              <mat-label *ngIf="!selectedDate">{{
                "Form.DateFormat" | translate
              }}</mat-label>
              <input
                matInput
                [matDatepicker]="picker"
                [(ngModel)]="selectedDate"
                (dateChange)="onFilterChange()"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <ul
          ngbNav
          #nav="ngbNav"
          [destroyOnHide]="true"
          [(activeId)]="activeTabId"
          class="nav nav-pills project-tab custom-tab"
        >
          <li [ngbNavItem]="'tooltip-tab-id'" id="tooltip-tab-id">
            <a ngbNavLink>
              <span (click)="tabChange('tooltip-tab-id')">Tooltips</span>
            </a>
            <ng-template ngbNavContent>
              <div class="row">&nbsp;</div>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th style="width: 10%; font-size: large">
                      {{ "Form.SCREEN" | translate }}
                    </th>
                    <th style="width: 45%; font-size: large">
                      {{ "Form.PRIMARY_LANGUAGE" | translate }} ({{
                        getLanguageName(currentProject.primaryLanguage)
                      }})
                    </th>
                    <th style="width: 45%; font-size: large">
                      {{ "Form.SUPPORTED_LANGUAGE" | translate }} ({{
                        getLanguageName(selectedLanguage)
                      }})
                    </th>
                  </tr>
                </thead>
                <tbody *ngIf="tooltipData.length; else noData">
                  <tr *ngFor="let item of tooltipData">
                    <td>{{ item?.screenDetails?.name }}</td>
                    <td>
                      <label> {{ item?.primaryLanguage?.name }} </label>
                      <p
                        [innerHtml]="sanitizeHtml(item?.primaryLanguage?.hint)"
                      ></p>
                      <span
                        >{{ "Form.Lastupdatedon" | translate }}
                        {{
                          item?.primaryLanguage?.updatedAt
                            | date : "dd MMM yyyy"
                        }}</span
                      >
                    </td>
                    <td>
                      <label class="m-2">
                        {{ item?.primaryLanguage?.name }}
                      </label>
                      <app-add-edit-translation
                        [data]="item?.supportedLanguage?.hint"
                        [placeholder]="'Form.NoDataAvailable' | translate"
                        [tooltipData]="item"
                        [languageId]="selectedLanguage"
                        (save)="onFilterChange()"
                      >
                      </app-add-edit-translation>
                      <span *ngIf="item?.supportedLanguage?.updatedAt"
                        >{{ "Form.Lastupdatedon" | translate }}
                        {{
                          item?.supportedLanguage?.updatedAt
                            | date : "dd MMM yyyy"
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
                <ng-template #noData>
                  <tbody>
                    <tr>
                      <td colspan="3" class="text-center">
                        {{ "Form.NoDataAvailable" | translate }}
                      </td>
                    </tr>
                  </tbody>
                </ng-template>
              </table>
            </ng-template>
          </li>
          <li [ngbNavItem]="'workflow-tab-id'" id="workflow-tab-id">
            <a ngbNavLink>
              <span (click)="tabChange('workflow-tab-id')">Workflows</span>
            </a>
            <ng-template ngbNavContent>
              <div class="row">&nbsp;</div>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th style="width: 10%; font-size: large">
                      {{ "Form.SCREEN" | translate }}
                    </th>
                    <th style="width: 45%; font-size: large">
                      {{ "Form.PRIMARY_LANGUAGE" | translate }} ({{
                        getLanguageName(currentProject?.primaryLanguage)
                      }})
                    </th>
                    <th style="width: 45%; font-size: large">
                      {{ "Form.SUPPORTED_LANGUAGE" | translate }} ({{
                        getLanguageName(selectedLanguage)
                      }})
                    </th>
                  </tr>
                </thead>
                <tbody *ngIf="workflowData.length; else noData">
                  <tr *ngFor="let item of workflowData">
                    <td>{{ item?.screenDetails?.name }}</td>

                    <td colspan="2">
                      <label>{{ item?.workflowDetails?.name }}</label>

                      <div
                        class="border p-2 m-2 row"
                        *ngFor="
                          let step of item?.workflowDetails?.workflowStepDetails
                        "
                      >
                        <!-- Primary Language Column -->
                        <div class="col-md-6">
                          <ng-container
                            *ngIf="step?.primaryLanguage as primary"
                          >
                            <input
                              class="form-control m-1 bg-light"
                              type="text"
                              [value]="primary.name"
                              readonly
                            />

                            <p
                              *ngIf="primary.workflowStepType === 'text'"
                              class="m-1 p-0"
                              [innerHtml]="sanitizeHtml(primary.intro)"
                            ></p>

                            <span class="m-1">
                              {{ "Form.Lastupdatedon" | translate }}
                              {{ primary.updatedAt | date : "dd MMM yyyy" }}
                            </span>
                          </ng-container>
                        </div>

                        <!-- Supported Language Column -->
                        <div class="col-md-6">
                          <ng-container
                            *ngIf="step?.supportedLanguage as supported"
                          >
                            <app-workflow-translation
                              [data]="supported.intro || ''"
                              [stepName]="supported.name || ''"
                              [placeholder]="'Form.NoDataAvailable' | translate"
                              [workflowData]="step"
                              [languageId]="selectedLanguage"
                              (save)="onFilterChange()"
                            >
                            </app-workflow-translation>

                            <span *ngIf="supported.updatedAt">
                              {{ "Form.Lastupdatedon" | translate }}
                              {{ supported.updatedAt | date : "dd MMM yyyy" }}
                            </span>
                          </ng-container>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <ng-template #noData>
                  <tbody>
                    <tr>
                      <td colspan="3" class="text-center">
                        {{ "Form.NoDataAvailable" | translate }}
                      </td>
                    </tr>
                  </tbody>
                </ng-template>
              </table>
            </ng-template>
          </li>

          <li [ngbNavItem]="'faq-tab-id'" id="faq-tab-id">
            <a ngbNavLink>
              <span (click)="tabChange('faq-tab-id')">{{
                "Form.FAQ" | translate
              }}</span>
            </a>
            <ng-template ngbNavContent>
              <div class="row">&nbsp;</div>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th style="width: 10%; font-size: large">
                      {{ "Form.SCREEN" | translate }}
                    </th>
                    <th style="width: 45%; font-size: large">
                      {{ "Form.PRIMARY_LANGUAGE" | translate }} ({{
                        getLanguageName(currentProject.primaryLanguage)
                      }})
                    </th>
                    <th style="width: 45%; font-size: large">
                      {{ "Form.SUPPORTED_LANGUAGE" | translate }} ({{
                        getLanguageName(selectedLanguage)
                      }})
                    </th>
                  </tr>
                </thead>
                <tbody *ngIf="faqData.length; else noData">
                  <tr *ngFor="let item of faqData">
                    <td>{{ item?.screenDetails?.name }}</td>
                    <td>
                      <label>{{ item?.primaryLanguage?.question }}</label>
                      <p
                        [innerHtml]="
                          sanitizeHtml(item?.primaryLanguage?.answer)
                        "
                      ></p>
                      <span
                        >{{ "Form.Lastupdatedon" | translate }}
                        {{
                          item?.primaryLanguage?.updatedAt
                            | date : "dd MMM yyyy"
                        }}</span
                      >
                    </td>
                    <td>
                      <app-faq-translation
                        [data]="item?.supportedLanguage?.answer"
                        [question]="item?.supportedLanguage?.question"
                        [placeholder]="'Form.NoDataAvailable' | translate"
                        [faqData]="item"
                        [languageId]="selectedLanguage"
                        (save)="onFilterChange()"
                      >
                      </app-faq-translation>
                      <span *ngIf="item?.supportedLanguage?.updatedAt"
                        >{{ "Form.Lastupdatedon" | translate }}
                        {{
                          item?.supportedLanguage?.updatedAt
                            | date : "dd MMM yyyy"
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
                <ng-template #noData>
                  <tbody>
                    <tr>
                      <td colspan="3" class="text-center">
                        {{ "Form.NoDataAvailable" | translate }}
                      </td>
                    </tr>
                  </tbody>
                </ng-template>
              </table>
            </ng-template>
          </li>
          <li [ngbNavItem]="'User Guide'" id="user-guide-tab-id">
            <a ngbNavLink>
              <span (click)="tabChange('User Guide')">User Guide</span>
            </a>
            <ng-template ngbNavContent>
              <div class="row">&nbsp;</div>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th style="width: 10%; font-size: large">
                      {{ "Form.SCREEN" | translate }}
                    </th>
                    <th style="width: 45%; font-size: large">
                      {{ "Form.PRIMARY_LANGUAGE" | translate }} ({{
                        getLanguageName(currentProject.primaryLanguage)
                      }})
                    </th>
                    <th style="width: 45%; font-size: large">
                      {{ "Form.SUPPORTED_LANGUAGE" | translate }} ({{
                        getLanguageName(selectedLanguage)
                      }})
                    </th>
                  </tr>
                </thead>
                <tbody *ngIf="userguideData.length; else noData">
                  <tr *ngFor="let item of userguideData">
                    <td>{{ item?.screenManagement?.name }}</td>
                    <td>
                      <p [innerHtml]="sanitizeHtml(item?.text)"></p>
                      <span
                        *ngIf="
                          (item?.supportedLanguages &&
                            item?.supportedLanguages?.updatedAt) ||
                          item?.updatedAt
                        "
                        >{{ "Form.Lastupdatedon" | translate }}
                        {{
                          item?.supportedLanguages?.updatedAt || item?.updatedAt
                            | date : "dd MMM yyyy"
                        }}</span
                      >
                    </td>
                    <td>
                      <app-userguide-translation
                        [data]="
                          (item?.supportedLanguages &&
                            item?.supportedLanguages?.text.trim()) ||
                          item?.text
                        "
                        [placeholder]="'Form.NoDataAvailable' | translate"
                        [userguideData]="item"
                        [languageId]="selectedLanguage"
                        (save)="onFilterChange()"
                        [languageList]="languageList"
                      >
                      </app-userguide-translation>
                      <span
                        *ngIf="
                          (item?.supportedLanguages &&
                            item?.supportedLanguages?.updatedAt) ||
                          item?.updatedAt
                        "
                        >{{ "Form.Lastupdatedon" | translate }}
                        {{
                          item?.supportedLanguages?.updatedAt || item?.updatedAt
                            | date : "dd MMM yyyy"
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
                <ng-template #noData>
                  <tbody>
                    <tr>
                      <td colspan="3" class="text-center">
                        {{ "Form.NoDataAvailable" | translate }}
                      </td>
                    </tr>
                  </tbody>
                </ng-template>
              </table>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav"></div>
      </div>
    </div>
  </div>
</div>
